import React, { useRef, useState } from 'react';
import Box from '../../../../components/Box';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { Helpers } from '../../../../helpers/Helpers';
import { useDispatch } from 'react-redux';
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';

export interface PostalCodeModel {
    postalCodeId: string,
    postalCodeStart: string,
    postalCodeEnd: string
    isSelected: boolean
    isAdded: boolean
}

interface Props {
    postalCodes: PostalCodeModel[]
    setPostalCodes: React.Dispatch<React.SetStateAction<PostalCodeModel[]>>
}

const PostalCodes = ({ postalCodes, setPostalCodes }: Props) => {
    const dispatch = useDispatch();
    const [postalCodeId, setPostalCodeId] = useState('');
    const [postalCodeStart, setPostalCodeStart] = useState('');
    const [postalCodeEnd, setPostalCodeEnd] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const postalCodesRef: any = useRef();

    const saveItem = () => {
        if (Helpers.isEmpty(postalCodeStart)) {
            toast.error('Posta Kodu Başlangıcı alanını doldurunuz!');
            return;
        }
        if (Helpers.isEmpty(postalCodeEnd)) {
            toast.error('Posta Kodu Bitişi alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(postalCodeId)) {
            var o: PostalCodeModel = {
                postalCodeStart: postalCodeStart,
                postalCodeEnd: postalCodeEnd,
                postalCodeId: Helpers.generateUUID(),
                isSelected: false,
                isAdded: true
            }

            setPostalCodes([...postalCodes, o])
        }
        else {
            setPostalCodes(postalCodes.map(function (x) {
                if (x.postalCodeId == postalCodeId) {
                    x.postalCodeStart = postalCodeStart;
                    x.postalCodeEnd = postalCodeEnd;
                    x.isSelected = false;
                }

                return x;
            }))
        }

        setPostalCodeId('');
        setPostalCodeStart('');
        setPostalCodeEnd('');
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = postalCodes.filter(x => x.isSelected)[0];

        setPostalCodeId(o.postalCodeId);
        setPostalCodeStart(o.postalCodeStart);
        setPostalCodeEnd(o.postalCodeEnd);
        setIsOpen(true);
        scrollTo();
    }

    const setItemSelected = (_id: string) => {
        setPostalCodes(postalCodes.map(function (x) {
            if (x.postalCodeId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = postalCodes.length == postalCodes.filter(x => x.isSelected).length;

        setPostalCodes(postalCodes.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = () => {
        setPostalCodes(postalCodes.filter(x => !x.isSelected));
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setPostalCodeId('');
        setPostalCodeStart('');
        setPostalCodeEnd('');
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = postalCodesRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    return (
        <div ref={postalCodesRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Posta Kodları</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Posta Kodu Başlangıcı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={postalCodeStart} onChange={(e) => setPostalCodeStart(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Posta Kodu Bitişi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={postalCodeEnd} onChange={(e) => setPostalCodeEnd(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={postalCodes.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={postalCodes.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={postalCodes.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={postalCodes.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={postalCodes.filter(x => x.isSelected).length > 0 && postalCodes.filter(x => x.isSelected).length == postalCodes.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Posta Kodu Başlangıcı</th>
                                            <th>Posta Kodu Bitişi</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            postalCodes.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            postalCodes.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.postalCodeId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.postalCodeStart}</td>
                                                    <td>{item.postalCodeEnd}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default PostalCodes;